import type { SelectInputOption } from '@interstate/components/SelectInput';
import type { BookType } from '@makemydeal/dr-platform-types';
import type { FMNames } from './types';

// NOTE: BB and GALVES are intentionally NOT keys — their absence triggers null/hidden rendering.
export const BOOK_SOURCE_TO_TYPE_OPTIONS: Partial<Record<BookType, SelectInputOption[]>> = {
    NADA: [{ value: 'Trade', label: 'Trade' }],
    KBB: [
        { value: 'FPP', label: 'Fair Purchase Price' },
        { value: 'Wholesale', label: 'Wholesale' }
    ]
};

export const REQUIRED_FIELD_LABELS: Partial<Record<FMNames, string>> = {
    wholesaleBookSource: 'Bookout Source',
    wholesaleValue: 'Bookout Value'
};
